var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMinimized(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.31641 15.6123C5.31641 15.1749 5.67101 14.8203 6.10843 14.8203H11.3886C11.826 14.8203 12.1806 15.1749 12.1806 15.6123V20.8925C12.1806 21.3299 11.826 21.6845 11.3886 21.6845C10.9512 21.6845 10.5966 21.3299 10.5966 20.8925V16.4044H6.10843C5.67101 16.4044 5.31641 16.0498 5.31641 15.6123Z",
    fill: "#404349"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6123 5.31641C16.0498 5.31641 16.4044 5.67101 16.4044 6.10843V10.5966H20.8925C21.3299 10.5966 21.6845 10.9512 21.6845 11.3886C21.6845 11.826 21.3299 12.1806 20.8925 12.1806H15.6123C15.1749 12.1806 14.8203 11.826 14.8203 11.3886V6.10843C14.8203 5.67101 15.1749 5.31641 15.6123 5.31641Z",
    fill: "#404349"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5086 4.49174C22.8179 4.80105 22.8179 5.30253 22.5086 5.61184L16.1724 11.948C15.8631 12.2574 15.3616 12.2574 15.0523 11.948C14.743 11.6387 14.743 11.1373 15.0523 10.828L21.3885 4.49174C21.6978 4.18244 22.1993 4.18244 22.5086 4.49174Z",
    fill: "#404349"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.95 15.0523C12.2593 15.3616 12.2593 15.8631 11.95 16.1724L5.61379 22.5086C5.30449 22.8179 4.803 22.8179 4.4937 22.5086C4.18439 22.1993 4.18439 21.6978 4.4937 21.3885L10.8299 15.0523C11.1392 14.743 11.6407 14.743 11.95 15.0523Z",
    fill: "#404349"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimized);
export default __webpack_public_path__ + "static/media/minimized.04483ed07f7eea19e8230255df4300c7.svg";
export { ForwardRef as ReactComponent };